import Vuex, { GetterTree } from 'vuex';
import { CourseState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<CourseState, RootState> = {
  selectedCourse: (state, getters) => {
    return state.course;
  },
  availableCourses: (state, getters) => {
    return state.availableCourses;
  },
};

export default getters;
